import dayjs from 'dayjs';
import CustomTimePicker from '../../components/TimePickerAnalog';
import { React, useEffect, useState, useForm, Alert, Icon, CustomSwitch, CustomModal, CustomTable, Toast, showDeleteOrRestoreMessage, Controller, Select, useUser } from '../../utils/commonImports';
import { Button } from "reactstrap";
import { customStyleMd } from '../../utils/common';
import { _api } from '../../auth/Api';
import { getPageRights } from '../../utils/accessPages';

const AppSettings = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    reset,
  } = useForm({
    defaultValues: {
      isBoolean: false,
      isEnabled: false
    },
  });
  const timeSetting = useForm({
    defaultValues: {
      startTime: dayjs().hour(9).minute(0), // 9:00 AM
      endTime: dayjs().hour(18).minute(0),  // 6:00 PM
      timeInterval: null
    }
  });
  const rolesc = [
    { title: "Code", dataIndex: "code" },
    { title: "Title", dataIndex: "title" },
    {
      title: "Is Enabled", dataIndex: "isEnabled",
      render: (isEnabled) => (
        <span className={`badge ${isEnabled ? 'bg-success' : 'bg-danger'}`}>
          {isEnabled ? 'Yes' : 'No'}
        </span>
      )
    },
  ];
  const timeIntervalOptions = [
    { value: 30, label: "30 minutes" },
    { value: 45, label: "45 minutes" },
    { value: 60, label: "1 hour" },
    { value: 90, label: "1.5 hours" },
    { value: 120, label: "2 hours" }
  ];
  const [loading, setLoading] = useState(false);
  const [loadingSetting, setLoadingSetting] = useState(false);
  const [showExample, setShowExample] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModalTime, setShowModalTime] = useState({ type: false, data: {} });
  const [AppSettingsList, setAppSettingsList] = useState([]);
  const [data, setData] = useState({});
  const [viewModal, setViewModal] = useState({ isOpen: false, data: null });
  const { loggedInUser } = useUser();
  const userPages = loggedInUser?.roles?.[0]?.pages || [];
  const rights = getPageRights(userPages, 9);

  useEffect(() => {
    _getAppSettings();
  }, [])

  const isBoolean = watch("isBoolean");
  const isEnabled = watch("isEnabled");

  const _getAppSettings = async () => {
    const skipAppSettings = ["AP-008", "AP-009", "AP-010", "AP-011"]
    try {
      await _api('GET', 'AppSetting/GetAppSettings?code=0', null, (r) => {
        if (r.isSuccess) {
          const filteredPages = r.data?.filter(p => !skipAppSettings.includes(p.code));
          setAppSettingsList(filteredPages);
        }
      });
    } catch (error) {
      console.log(error)
    }
  };

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const finalPayload = {
        ...data,
        isEnabled: data.isEnabled, // 11 Sep se pehle ye !data.isEnabled tha
        value: !data.isBoolean ? data.value : "",
      };
      // if (data.isBoolean) {
      //   JSON.parse(data.value);
      // }
      let url = data && data?.id > 0 ? "AppSetting/UpdateAppSetting" : "AppSetting/AddAppSetting"
      await _api("POST", url, finalPayload, (res) => {
        if (res.isSuccess) {
          Toast.fire({ icon: "success", title: res.message });
          _getAppSettings();
          setShowModal(false);
          reset();
          setShowExample(false)
        } else {
          Toast.fire({ icon: "error", title: res.message });
        }
      });
    } catch (err) {
      Toast.fire({ icon: "error", title: "Invalid JSON format in Value field!" });
    }
    setLoading(false);
  };

  const launchDetailModal = (type, record) => {
    setViewModal({ isOpen: type, data: record });
  };

  const _deleteAppSetting = async (d) => {
    const isConfirmed = await showDeleteOrRestoreMessage(d?.isActive ? "Delete" : "Restore");
    if (isConfirmed) {
      try {
        await _api('POST', `AppSetting/DeleteAppSetting`, d?.id, function (res) {
          if (res.isSuccess) {
            Toast.fire({ icon: 'success', title: res.message })
            _getAppSettings();
          } else {
            Toast.fire({ icon: 'error', title: res.message })
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  };

  const launchModal = (data = {}, type) => {
    setShowExample(false)
    reset();
    if (Object.keys(data).length > 0) {
      setValue("id", data.id || "");
      setValue("code", data.code || "");
      setValue("title", data.title || "");
      setValue("isBoolean", data.isBoolean || false);
      setValue("value", data.value || "");
      //setValue("isEnabled", data.isEnabled || false);
      setData(data)
    } else {
      setData({})
    }
    setShowModal(type);
  };

  const config = {
    info: (
      <>
        This section controls how the mobile app initializes. If <strong>IsBoolean</strong> is enabled,
        paste a valid JSON in the Value field to define the app layout. If not, the app will simply mark
        the setting as <strong>enabled</strong> without using any JSON structure.
      </>
    ),
    example: `
  {
    "screen": "Home",
    "components": [
      {
        "type": "banner",
        "image": "https://example.com/banner.jpg",
        "action": "navigate",
        "target": "ProductList"
      },
      {
        "type": "button",
        "text": "Shop Now",
        "action": "navigate",
        "target": "Shop"
      }
    ]
  }
  `
  };

  const isJsonString = (str) => {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  };

  const generateTimeSlots = (startTime, endTime, intervalInMinutes) => {
    const slots = [];
    let current = dayjs(startTime, "HH:mm");
    let end = dayjs(endTime, "HH:mm");

    if (end.isBefore(current)) {
      end = end.add(1, "day");
    }

    while (current.isBefore(end) || current.isSame(end)) {
      slots.push(current.format("HH:mm"));
      current = current.add(intervalInMinutes, "minute");
    }

    return slots;
  };

  const launchModalTime = ({ type, data }) => {
    if (data && Object.keys(data).length > 0) {
      const timeArray = JSON.parse(data.value);
      const startTime = dayjs(timeArray[0], "HH:mm");
      const endTime = dayjs(timeArray[timeArray.length - 1], "HH:mm");

      timeSetting.setValue("startTime", startTime);
      timeSetting.setValue("id", data.id);
      timeSetting.setValue("endTime", endTime);

      setShowModalTime({ type, data: { startTime, endTime } });
    } else {
      timeSetting.reset();
      setShowModalTime({ type, data: null });
    }
  };
  const _saveTime = async (data) => {
    const { startTime, endTime, timeInterval } = data;
    const slots = generateTimeSlots(startTime, endTime, parseInt(timeInterval));

    setLoadingSetting(true);
    try {
      const finalPayload = {
        id: data.id,
        code: "AP-006",
        title: "TimeSlots",
        isBoolean: false,
        value: JSON.stringify(slots),
        isEnabled: true,
      };
      //let url = data && data?.id > 0 ? "AppSetting/UpdateAppSetting" : "AppSetting/AddAppSetting"
      await _api("POST", "AppSetting/UpdateAppSetting", finalPayload, (res) => {
        if (res.isSuccess) {
          Toast.fire({ icon: "success", title: res.message });
          _getAppSettings();
          setShowModalTime({ type: false, data: {} });
          timeSetting.reset();
        } else {
          Toast.fire({ icon: "error", title: res.message });
        }
      });
    } catch (err) {
      Toast.fire({ icon: "error", title: "API Error" });
    }
    setLoadingSetting(false);
  };

  return (
    <div>
      {rights && rights.add && (
        <div className="d-flex justify-content-end gap-2" style={{ marginBottom: "10px" }}>
          <button
            onClick={() => launchModal({}, true)}
            className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
            style={{ lineHeight: '1.2' }}
          >
            Add App Setting <Icon icon="mdi:plus-circle-outline" className="text-md" />
          </button>
          {/* <button
          onClick={() => launchModalTime({type:true, data:{}})}
          className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
          style={{ lineHeight: '1.2' }}
        >
          Time Setting <Icon icon="mdi:plus-circle-outline" className="text-md" />
        </button> */}
        </div>)}
      <CustomTable
        columns={rolesc}
        dataSource={AppSettingsList}
        options={{
          //  pageKey:"Roles Management",
          pageKey: 9,
          withActions: true,
          showEdit: true,
          showDelete: false,
          showView: true,
          loading: false,
          rowKey: "id",
          bordered: true,
          size: "small",
          emptyText: "No App Settings found",
        }}
        onView={(d) => launchDetailModal(true, d)}
        onEdit={(rowData) => {
          if (rowData.code === "AP-006") {
            launchModalTime({ type: true, data: rowData })
          } else {
            launchModal(rowData, true);
          }
        }}
        onDelete={(d) => _deleteAppSetting(d)}
      />

      {/* Modal with Form */}
      <CustomModal
        title={data && Object.keys(data).length > 0 ? "Update App Setting" : "Add App Setting"}
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
      >
        <Alert type="info" showIcon closable message="App Settings Info" className="mb-3" description={config.info}
        />
        <form onSubmit={handleSubmit(onSubmit)} className="row">
          <div className="col-md-6">
            <div className="form-group mb-3 input-group-md">
              <label className="small">Code</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter code"
                {...register("code", { required: "Code is required" })}
                disabled={data && Object.keys(data).length > 0 ? true : false}
              />
              {errors.code && (
                <span className="badge text-xs fw-normal text-danger-600 bg-danger-100 py-4 radius-4 text-white">
                  {errors.code.message}
                </span>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group mb-3 input-group-md">
              <label className="small">Title</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter title"
                {...register("title", { required: "Title is required" })}
                disabled={data && Object.keys(data).length > 0 ? true : false}
              />
              {errors.title && (
                <span className="badge text-xs fw-normal text-danger-600 bg-danger-100 py-4 radius-4 text-white">
                  {errors.title.message}
                </span>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group mb-3 input-group-md mt-2">
              <label className="small">Is Boolean?</label>
              <CustomSwitch
                id="isBoolean"
                checked={isBoolean}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setValue("isBoolean", checked);
                  if (checked) {
                    setValue("value", "");
                  }
                }}

              />
            </div>
          </div>

          {isBoolean && (
            <div className="col-md-4">
              <div className="form-group mb-3 input-group-md mt-2">
                <label className="small">Is Enabled?</label>
                <CustomSwitch
                  id="isEnabled"
                  checked={isEnabled}
                  onChange={(e) => setValue("isEnabled", e.target.checked)}
                />
              </div>
            </div>
          )}

          {!isBoolean && (
            <div className="col-12">
              <div className="form-group mb-3 input-group-md">
                <div className="d-flex justify-content-between align-items-center">
                  <label className="small mb-1">Value (Paste JSON here)</label>
                  <button
                    type="button"
                    className="btn btn-link p-0 text-decoration-underline small btn-sm"
                    onClick={() => setShowExample(!showExample)}
                  >
                    {showExample ? "Hide Example" : "Show Example"}
                  </button>
                </div>
                <textarea
                  rows={6}
                  className="form-control"
                  placeholder="Paste your JSON"
                  {...register("value", {
                    validate: (val) => {
                      if (isBoolean) return true;

                      if (!val?.trim()) return "Value is required";

                      if (!isBoolean) {
                        try {
                          JSON.parse(val);
                          return true;
                        } catch {
                          return "Invalid JSON format";
                        }
                      }

                      return true;
                    }
                  })}
                />
                {errors.value && (
                  <span className="badge text-xs fw-normal text-danger-600 bg-danger-100 py-4 radius-4 text-white mt-1 d-inline-block">
                    {errors.value.message}
                  </span>
                )}

                {showExample && (
                  <pre className="bg-light border rounded mt-2 p-2 small">{config.example}</pre>
                )}
              </div>
            </div>
          )}

          <div className="col-12 mt-2">
            <Button className="btn btn-changan btn-sm float-end" type="submit" disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {" "}Saving...
                </>
              ) : (
                data && Object.keys(data).length > 0 ? "Update" : "Save"
              )}
            </Button>
          </div>
        </form>
      </CustomModal>

      <CustomModal
        title="Select Time Settings"
        show={showModalTime.type}
        onHide={() => setShowModalTime({ type: false, data: {} })}
        size="lg"
      >
        <form onSubmit={timeSetting.handleSubmit(_saveTime)} className="row g-3">
          <div className="col-md-6">
            <label className="small fw-bold">Start Time</label>
            <Controller
              name="startTime"
              control={timeSetting.control}
              rules={{ required: "Start Time is required" }}
              render={({ field }) => (
                <CustomTimePicker
                  value={field.value}
                  onChange={field.onChange}
                />
              )}
            />
            {timeSetting.errors?.startTime && <span className="text-danger small">{timeSetting.errors?.startTime.message}</span>}
          </div>

          <div className="col-md-6">
            <label className="small fw-bold">End Time</label>
            <Controller
              name="endTime"
              control={timeSetting.control}
              rules={{ required: "End Time is required" }}
              render={({ field }) => (
                <CustomTimePicker
                  value={field.value}
                  onChange={field.onChange}
                />
              )}
            />
            {timeSetting.errors?.endTime && <span className="text-danger small">{timeSetting.errors?.endTime.message}</span>}
          </div>

          <div className="col-12 mb-3">
            <div className="form-group">
              <label className="small fw-bold">Time Interval</label>
              <Controller
                name="timeInterval"
                control={timeSetting.control}
                rules={{ required: "Time Interval is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={timeIntervalOptions}
                    isClearable
                    placeholder="Time Interval"
                    value={timeIntervalOptions.find(option => option.value === field.value)}
                    onChange={(selectedOption) => field.onChange(selectedOption?.value)}
                    styles={customStyleMd}
                  />
                )}
              />
              {timeSetting.formState.errors?.timeInterval && (
                <span className="text-danger small">{timeSetting.formState?.errors?.timeInterval?.message}</span>
              )}
            </div>
          </div>

          <div className="col-12 text-end mt-2">
            <Button className="btn btn-changan btn-sm float-end" type="submit" disabled={loadingSetting}>
              {loadingSetting ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {" "}Updating...
                </>
              ) : (
                // data && Object.keys(data).length > 0 ? "Update" : "Save"
                "Update"
              )}
            </Button>
            {/* <Button type="submit" className="btn btn-changan btn-sm">
        Save Time Settings
      </Button> */}
          </div>
        </form>
      </CustomModal>

      <CustomModal
        title="View App Setting"
        show={viewModal.isOpen} size="lg"
        onHide={() => setViewModal(false, {})}
      >
        {viewModal.data && (
          <div className="row g-3">
            {/* Code */}
            <div className="col-md-3">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Code:</small>
                <div className="fw-semibold text-sm">{viewModal.data.code}</div>
              </div>
            </div>

            {/* Title */}
            <div className="col-md-3">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Title:</small>
                <div className="fw-semibold text-sm">{viewModal.data.title}</div>
              </div>
            </div>

            {/* Is Boolean */}
            <div className="col-md-3">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Is Boolean:</small>
                <div>
                  <span className={`badge ${viewModal.data.isBoolean ? "bg-success" : "bg-danger"}`}>
                    {viewModal.data.isBoolean ? "Yes" : "No"}
                  </span>
                </div>
              </div>
            </div>

            {/* Is Enabled */}
            <div className="col-md-3">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Is Enabled:</small>
                <div>
                  <span className={`badge ${viewModal.data.isEnabled ? "bg-success" : "bg-danger"}`}>
                    {viewModal.data.isEnabled ? "Yes" : "No"}
                  </span>
                </div>
              </div>
            </div>

            {/* JSON Value */}
            <div className="col-12">
              <div className="border rounded p-3 bg-light shadow-sm">
                <small className="text-muted d-block mb-2">Value:</small>
                <pre className="bg-white border rounded p-3 mb-0 text-break small" style={{ maxHeight: "250px", overflowY: "auto" }}>
                  {
                    isJsonString(viewModal.data.value)
                      ? JSON.stringify(JSON.parse(viewModal.data.value), null, 2)
                      : viewModal.data.value
                  }
                </pre>
              </div>
            </div>
          </div>
        )}

      </CustomModal>

    </div>
  );
};

export default AppSettings;